module.exports = __webpack_public_path__ + "static/media/carousal3.1665d786.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousal3.jpg
// module id = 310
// module chunks = 0